module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-get-started-large@2x.88029596.png";